import { useEffect, useState } from "react";

const fetchSitemapXML = async () => {
    const response = await fetch('https://www.haloholidays.co.uk/sitemap.xml');
    const text = await response.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(text, "application/xml");
    return xmlDoc;
  };
  
  const extractDestinations = (xmlDoc: Document): string[] => {
    const urls = Array.from(xmlDoc.getElementsByTagName('loc'));
    return urls
      .map(url => url.textContent)
      .filter((url): url is string => url !== null && url.startsWith('https://www.haloholidays.co.uk/destinations/'));
  };

  const extractBlogs = (xmlDoc: Document): string[] => {
    const urls = Array.from(xmlDoc.getElementsByTagName('loc'));
    return urls
      .map(url => url.textContent)
      .filter((url): url is string => url !== null && url.startsWith('https://www.haloholidays.co.uk/blogs/'));
  };

  const extractResorts = (xmlDoc: Document): string[] => {
    const urls = Array.from(xmlDoc.getElementsByTagName('loc'));
    return urls
      .map(url => url.textContent)
      .filter((url): url is string => url !== null && url.startsWith('https://www.haloholidays.co.uk/resort/'));
  };
  

const SitemapPage = () => {
    const [destinationLinks, setDestinationLinks] = useState<string[]>([]);
    const [blogLinks, setBlogLinks] = useState<string[]>([]);
    const [resortsLinks, setResortsLinks] = useState<string[]>([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        const loadSitemap = async () => {
          try {
            const xmlDoc = await fetchSitemapXML();
            const blogs = extractBlogs(xmlDoc);
            setBlogLinks(blogs)
            const destinations = extractDestinations(xmlDoc);
            setDestinationLinks(destinations);
            const resorts = extractResorts(xmlDoc);
            setResortsLinks(resorts);
          } catch (error) {
            console.error("Failed to load sitemap:", error);
          }
        };
    
        loadSitemap();
      }, []);
    
  return (
    <div className="container mx-auto p-8">
      <h1 className="text-3xl font-bold text-center mb-4 mt-4">Sitemap</h1>
      <hr className="mb-10"/>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        
        {/* Main Section */}
        <div>
          <h2 className="text-xl font-semibold mb-4">Main</h2>
          <ul className="space-y-2 sitemap-bullet text-sm ml-4">
            <li><a href="https://www.haloholidays.co.uk/" className="hover:text-blue-500">Home</a></li>
            <li><a href="https://www.haloholidays.co.uk/destinations" className="hover:text-blue-500">Destinations</a></li>
            <li><a href="https://www.haloholidays.co.uk/blogs" className="hover:text-blue-500">Blogs</a></li>
            <li><a href="https://www.haloholidays.co.uk/contact-us" className="hover:text-blue-500">Contact Us</a></li>
            <li><a href="https://www.haloholidays.co.uk/about-us" className="hover:text-blue-500">About Us</a></li>
            <li><a href="https://www.haloholidays.co.uk/terms" className="hover:text-blue-500">Privacy Policy</a></li>
            <li><a href="https://www.haloholidays.co.uk/sitemap" className="hover:text-blue-500">Sitemap</a></li>
            {/* <li><a href="#" className="hover:text-blue-500">Flash Deals</a></li>
            <li><a href="#" className="hover:text-blue-500">Last Minute Deals</a></li>
            <li><a href="#" className="hover:text-blue-500">E-Books</a></li> */}
          </ul>
        </div>
        
        {/* Holidays Section */}
        <div>
          <h2 className="text-xl font-semibold mb-4">Holiday Types</h2>
          <ul className="space-y-2 sitemap-bullet text-sm ml-4">
            <li><a href="https://www.haloholidays.co.uk/all-inclusive-holidays" className="hover:text-blue-500">All Inclusive Holidays</a></li>
            <li><a href="https://www.haloholidays.co.uk/beach-holidays" className="hover:text-blue-500">Beach Holidays</a></li>
            <li><a href="https://www.haloholidays.co.uk/couple-holidays" className="hover:text-blue-500">Couple Holidays</a></li>
            <li><a href="https://www.haloholidays.co.uk/family-holidays" className="hover:text-blue-500">Family Holidays</a></li>
            <li><a href="https://www.haloholidays.co.uk/honeymoon-holidays" className="hover:text-blue-500">Honeymoon Holidays</a></li>
            <li><a href="https://www.haloholidays.co.uk/last-minute-holidays" className="hover:text-blue-500">Last Minute Holidays</a></li>
            <li><a href="https://www.haloholidays.co.uk/luxury-holidays" className="hover:text-blue-500">Luxury Holidays</a></li>
          </ul>
        </div>

      </div>

      <div className="border-b border-bottom-light pb-10" />

      {/* Blogs Section */}
      <div className="mt-10">
        <h2 className="text-xl font-semibold mb-4">Blogs</h2>
        <ul className="grid grid-cols-2 gap-x-6 space-y-2 sitemap-bullet text-sm ml-4">
            {blogLinks.map((link) => (
                <li key={link}>
                    <a href={link} className="hover:text-blue-500">
                        {link.split('/').pop()?.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                    </a>
                </li>
            ))}
        </ul>
      </div>

      <div className="border-b border-bottom-light pb-10" />

      {/* Destinations Section */}
      <div className="mt-10">
            <h2 className="text-xl font-semibold mb-4">Destinations</h2>
            <ul className="grid grid-cols-4 gap-x-6 space-y-2 sitemap-bullet text-sm ml-4">
                {destinationLinks.map((link) => (
                <li key={link}>
                    <a href={link} className="hover:text-blue-500">
                    {link.split('/').pop()?.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                    </a>
                </li>
                ))}
            </ul>
      </div>

      <div className="border-b border-bottom-light pb-10" />

      {/* Resorts Section */}
      <div className="mt-10">
        <h2 className="text-xl font-semibold mb-4">Resorts</h2>
        <ul className="grid grid-cols-3 gap-x-6 space-y-2 sitemap-bullet text-sm ml-4">
            {resortsLinks.map((link) => (
            <li key={link}>
                <a href={link} className="hover:text-blue-500">
                    {link.split('/').pop()?.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                </a>
            </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default SitemapPage;